import { BookOpen, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { Button } from "../../../components/ui/button";

// Cola do atendente. Os valores espelham o gestorCheckoutHandler (deságio, piso
// de R$ 0,50 no valor de compra, redutor por franquia) e os textos da triagem do
// chatwoot (orientacaoTaxas): mudou a regra lá, mude aqui.

interface Bloco {
  titulo: string;
  itens: React.ReactNode[];
}

const OPERACOES: Bloco[] = [
  {
    titulo: "Entrego (franquias rayo, rayosp, bee…)",
    itens: [
      "Oferta = saldo de ontem × redutor da franquia. Gorjetas não entram.",
      <>
        <strong>Redutor</strong>: % do saldo que a franquia libera para antecipar
        (ex.: 0,8 = 80%). O resto vem no repasse semanal.
      </>,
      <>
        <strong>Taxa</strong>: 2,3% do valor antecipado, mínimo R$ 1,50.
      </>,
      <>
        <strong>Mínimo</strong>: valor de compra ≥ R$ 0,50, ou seja, saldo (já com
        redutor) ≥ R$ 2,00.
      </>,
      "Uma oferta por franquia em que o entregador rodou.",
      "Relatórios chegam entre 9h30 e 10h30; a oferta sai depois do checkout.",
      <>
        Franquia com <strong>NFS</strong>: a nota precisa ser emitida antes do aceite,
        pelo DUES, pelo nosso emissor nacional ou por emissão própria (o entregador
        envia o PDF da nota).
      </>,
    ],
  },
  {
    titulo: "iMile (franquia + base, ex.: realogtji)",
    itens: [
      "Oferta = saldo de ontem × redutor da franquia.",
      <>
        <strong>Taxa</strong>: 7,2% do valor antecipado, sem mínimo.
      </>,
      <>
        <strong>Mínimo</strong>: valor de compra ≥ R$ 0,50 (saldo ≈ R$ 0,54).
      </>,
      "O cadastro é da franquia (ex.: realog) e vale para todas as bases dela; sai uma oferta por base.",
      "Relatórios chegam às 10h, 14h e 18h: a oferta pode sair mais tarde que a da Entrego.",
    ],
  },
  {
    titulo: "Muve",
    itens: [
      "Oferta = saldo total de ontem (pedidos + garantido), sem redutor.",
      <>
        <strong>Taxa</strong>: R$ 7,50 fixo por antecipação.
      </>,
      <>
        <strong>Mínimo</strong>: saldo ≥ R$ 8,00 (compra ≥ R$ 0,50).
      </>,
      "O telefone que a Muve informa no relatório precisa bater com o do cadastro.",
    ],
  },
  {
    titulo: "Regras gerais",
    itens: [
      "Antecipação é sempre do saldo do dia anterior. O que não for antecipado vem no repasse semanal (datas com a empresa).",
      "Ofertas saem pela manhã, depois que os relatórios chegam e o checkout é confirmado. Pagamento até o final da tarde.",
      <>
        A oferta vai para o telefone do <strong>cadastro ativo mais recente</strong>{" "}
        (na Entrego e na iMile, o da franquia; na Muve, o cadastro cujo telefone bate
        com o do relatório). Trocou de número = novo cadastro.
      </>,
      "Telefone que já recebeu oferta no dia não recebe outra.",
      <>
        <strong>Troca de PIX</strong>: no WhatsApp, Menu Principal → "Trocar chave PIX".
        O pagamento usa a chave do aceite; trocar depois só repaga o que falhou nos
        últimos 5 dias. Se o PIX falhar, o bot já pede a chave nova.
      </>,
      "Cadastro é aprovado em até 2 dias úteis. CNPJ, franquia e ativo/inativo: Cedentes › Editar.",
    ],
  },
];

const STORAGE_KEY = "suporte.referenciaAberta";

const lerAberta = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) !== "false";
  } catch {
    return true;
  }
};

export function ReferenciaOperacoes() {
  const [aberta, setAberta] = useState(lerAberta);

  const alternar = () => {
    const nova = !aberta;
    setAberta(nova);
    try {
      localStorage.setItem(STORAGE_KEY, String(nova));
    } catch {
      // sem storage: só não lembra a escolha
    }
  };

  return (
    <div className="mb-4 rounded-lg border bg-card">
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <BookOpen className="h-4 w-4 text-primary" />
          Referência rápida das operações
        </div>
        <Button variant="ghost" size="sm" onClick={alternar} aria-expanded={aberta}>
          {aberta ? <ChevronUp /> : <ChevronDown />}
          {aberta ? "Ocultar" : "Mostrar"}
        </Button>
      </div>
      {aberta && (
        <div className="grid max-h-[40vh] grid-cols-1 gap-4 overflow-y-auto border-t px-4 py-3 md:grid-cols-2 xl:grid-cols-4">
          {OPERACOES.map(({ titulo, itens }) => (
            <section key={titulo}>
              <h3 className="mb-1 text-xs font-semibold uppercase text-muted-foreground">{titulo}</h3>
              <ul className="list-disc space-y-1 pl-4 text-xs leading-relaxed">
                {itens.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
